module.exports = __webpack_public_path__ + "static/media/profile-about-1.2d15977b.jpg";